export enum AvatarSizeEnum {
  extraSmall = 20,
  small = 29,
  medium = 42,
  extraMedium = 54,
  large = 100,
  extraLarge = 150,
  chatGroupAvatar = 80,
}
